module.exports = __webpack_public_path__ + "static/check2-a7e3d16844e26cc87689725ae9e39a12.png";